import { Greeting } from 'components/Greeting';
import { Page } from 'components/Page/Page';
import { RegionDropdown } from 'layouts/AppPageTemplate/desktop/DesktopNav/RegionDropdown';
import * as React from 'react';

import { Navigate } from 'react-router-dom';
import { Routes } from 'constants/pages';
import { useIsDashboardUser } from 'utils/permissions/hooks';
import { Menu } from './Menu';

export const Landing: React.FC = () => {
  const shouldNavigate = useIsDashboardUser();
  if (shouldNavigate) {
    return <Navigate to={Routes.ShipmentsDashboard} />;
  }

  return (
    <Page className="p-16 pt-8 space-y-4">
      <Greeting />
      <p className="text-gray-600">Here’s an overview of what you can achieve with BlueCargo!</p>
      <div className="space-y-6">
        <RegionDropdown className="shadow-sm" />
        <Menu />
      </div>
    </Page>
  );
};
Landing.displayName = 'Landing';
